import { Env } from "../../env";
import { ApiClient } from "../../http/api_client";
import { LampEasySearchJsEnv, RefinementSearchElement } from "../../models/lamp/lamp_js_env";

export class LampEasySearchRepository {
  async getRefinementSearchElements(
    refinementType: number | null,
    refinementLevel: number | null,
    refinementCondition1: string
  ): Promise<LampEasySearchJsEnv> {
    const result = await ApiClient.get(
      Env.SETTING.userPublicApi.urlBase +
      `api/attract/search/refinementSearchElements/?refinementType=${(refinementType !== null) ? refinementType : ''}&refinementLevel=${(refinementLevel !== null) ? refinementLevel : ''}&refinementCondition1=${refinementCondition1}&refinementCondition2`
    );

    const refinementSearchElements = result.refinementSearchElements.map((refinementSearchElement: { refinementSearchDisplayName: string; refinementSearchParameter: string; }) =>
      new RefinementSearchElement(
        refinementSearchElement.refinementSearchDisplayName,
        refinementSearchElement.refinementSearchParameter
      )
    );

    return new LampEasySearchJsEnv(refinementSearchElements, '', '');
  }
}